import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import HttpClient from "libs/utils/HttpClient";
import { format } from "date-fns";
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  wrapContent: {
    marginTop: 30,
  },
  sigPad: { width: "100%", height: "100%" },
  buttons: { width: "100%", height: "30px" },
  wrapSig: {
    padding: "10px",
    border: "1px solid lightgray",
    borderRadius: "10px",
    textAlign: "center",
  },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "80%",
    height: "80%",
    backgroundColor: "white",
    borderRadius: 15,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  wrapDateControl: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: 15,
  },
  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  wrapContoller: {
    display: "flex",
  },
  formControl: {
    width: "100%",
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
  },
}));

function ListPersonalDetail() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const [data, setData] = useState([]);

  useEffect(async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/personal/list?personalID=${params.id}`
      );

      // console.log(response);
      if (response.status) {
        if (response.results.length > 0) {
          setData(response.results);
        }
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }, []);

  useEffect(async () => {});

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Personal Log" />
      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="Personal Detail" />
      </div>

      <div className={classes.wrapContent}>
        <Grid container spacing={3}>
          <Card style={{ width: "100%" }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Infomation
              </Typography>
              <hr />
              <Typography variant="body1" color="text.secondary">
                Name : {data[0]?.firstName}&nbsp; {data[0]?.middleName}&nbsp;{" "}
                {data[0]?.middleName}
                {data[0]?.lastName}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Email : {data[0]?.email}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Mobile : {data[0]?.mobile}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Username : {data[0]?.username}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                User Type : {data[0]?.roleName}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Registered Date :{" "}
                {data[0]?.createDate
                  ? format(new Date(data[0]?.createDate), "yyyy-MM-dd hh:mm:ss")
                  : null}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Activated : {data[0]?.isConfirmEmail ? "YES" : "NO"}
              </Typography>
            </CardContent>
          </Card>

          <Box width="100%" />

          {/* <Grid item xs={12} md={4}>
            {
              <div
                dangerouslySetInnerHTML={{
                  __html: location?.state?.data?.body,
                }}
              />
            }
          </Grid> */}
          <Card style={{ width: "100%", marginTop: 20 }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Email Log
              </Typography>

              {data[0]?.emailLog.map((x, index) => {
                return (
                  <>
                    <Card style={{ width: "100%", marginTop: 20 }}>
                      <CardContent>
                        <div className={classes.wrapDateControl}>
                          <Button
                            variant="contained"
                            size="medium"
                            color="primary"
                            type="submit"
                            style={{ width: 100 }}
                            onClick={async () => {
                              const data = {
                                logEmailID: x?.logEmailID,
                              };
                              try {
                                const response = await HttpClient.post(
                                  "/api/mail/resend",
                                  data
                                );

                                if (response.status) {
                                  alert(response.message);
                                } else {
                                  alert(response.message);
                                }
                                if (response.status) return response;
                                return Promise.reject(response);
                              } catch (error) {
                                const newError = error;
                                throw newError;
                              }
                            }}
                            className={classes.buttonDialogSave}
                          >
                            Resend
                          </Button>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            // __html: location?.state?.data?.emailLog,
                            __html: x?.body,
                          }}
                        />
                      </CardContent>
                    </Card>
                  </>
                );
              })}
            </CardContent>
          </Card>
          <Grid item xs={12} md={4}></Grid>
        </Grid>
      </div>
    </Paper>
  );
}

export default ListPersonalDetail;
